const galeria = () => {
    const galerias = [].slice.call(document.querySelectorAll('.desactiva__investigacion__galeria')) as HTMLElement[];
    console.log(galerias);

    galerias.forEach(galeria => {
        const imagenes = [].slice.call(galeria.querySelectorAll('.desactiva__investigacion__galeria__imagen')) as HTMLImageElement[];

        if (imagenes.length < 2) {
            return;
        }

        let actual = 0;

        const navegacion = document.createElement('div'),
            prev = document.createElement('button'),
            next = document.createElement('button'),
            contador = document.createElement('div'),
            actualiza = (posicion: number) => {
                imagenes[actual].classList.remove('is-visible');
                actual = posicion;
                imagenes[actual].classList.add('is-visible');
                contador.innerHTML = (actual + 1) + ' / ' + imagenes.length;
            },
            anterior = () => actualiza(actual === 0 ? imagenes.length - 1 : actual - 1),
            siguiente = () => actualiza(actual === imagenes.length - 1 ? 0 : actual + 1)

        navegacion.classList.add('desactiva__investigacion__galeria__navegacion');
        prev.classList.add('desactiva__investigacion__galeria__navegacion__prev');
        next.classList.add('desactiva__investigacion__galeria__navegacion__next');
        prev.innerHTML = '<';
        contador.innerHTML = '1 / ' + imagenes.length;
        next.innerHTML = '>';
        navegacion.appendChild(prev);
        navegacion.appendChild(contador);
        navegacion.appendChild(next);

        prev.addEventListener('click', anterior);
        next.addEventListener('click', siguiente);

        galeria.appendChild(navegacion);
    });
}

export default galeria;